import { msg } from '@/shared/i18n/msg';
import type { RepeatUnit } from '../schemas/repeat-unit';

/** The unit in the editor's select, and the "every N …" phrase (one, other) in lists. */
export const REPEAT_UNIT_LABELS: Readonly<
  Record<RepeatUnit, { readonly unit: string; readonly one: string; readonly other: string }>
> = {
  days: { unit: msg('days'), one: msg('every {count} day'), other: msg('every {count} days') },
  weeks: { unit: msg('weeks'), one: msg('every {count} week'), other: msg('every {count} weeks') },
  months: { unit: msg('months'), one: msg('every {count} month'), other: msg('every {count} months') },
  years: { unit: msg('years'), one: msg('every {count} year'), other: msg('every {count} years') },
};
